import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { relativeLoader } from 'src/common/utils/imageHelpers';
import { NEXT_STATIC_IMAGES, SHARED_MEDIA_QUERIES as sharedMediaQueries } from 'src/common/constants';
import { CarouselProvider } from 'src/common/providers/CarouselProvider';
import Carousel from 'src/common/components/dockyard/Carousel';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import styles from './Hero.module.scss';

const Hero: FC = () => {
  const [t] = useTranslation('safety-page');
  const temp = [0, 1, 2, 3];

  return (
    <PitchPageLayout
      backgroundColor="ivory"
      variant="header"
      outerChildren={(
        <div className={styles.outer}>
          <CarouselProvider
            emblaOptions={{
              active: true,
              breakpoints: {
                [sharedMediaQueries.xxl]: {
                  active: false,
                },
              },
            }}
          >
            <Carousel>
              {temp.map((i) => (
                <Image
                  key={i}
                  className={styles.carouselImage}
                  src={`${NEXT_STATIC_IMAGES}safety/safety-carousel--${i}.jpg`}
                  loader={relativeLoader}
                  width={265}
                  height={170}
                  alt={t(`safety-carousel--${i}--alt`)}
                  loading="eager"
                  priority={i === 0}
                />
              ))}
            </Carousel>
          </CarouselProvider>
        </div>
      )}
    >
      <div className={styles.root}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={`${NEXT_STATIC_IMAGES}safety/hero-graphic.svg`}
          width={154}
          height={80}
          alt={t('hero--graphic--alt')}
          loading="eager"
        />
        <div className={styles.title}>
          <Typography
            type="h1"
            size="display-4"
            sizeFromBreakpointM="display-3"
          >
            {t('hero--title')}
          </Typography>
        </div>
        <div className={styles.text}>
          <Typography type="p" size="body-xl">
            {t('hero--text')}
          </Typography>
        </div>
      </div>
    </PitchPageLayout>
  );
};

export default Hero;
